import { render, staticRenderFns } from "./CotizadorServicios.vue?vue&type=template&id=66f52db4&scoped=true&"
import script from "./CotizadorServicios.vue?vue&type=script&lang=js&"
export * from "./CotizadorServicios.vue?vue&type=script&lang=js&"
import style0 from "./CotizadorServicios.vue?vue&type=style&index=0&id=66f52db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f52db4",
  null
  
)

export default component.exports